<template>
<div>
    <h5 class="card-title">{{$t('content.lesson.upload')}}:</h5>
    <img
        @load="load"
        id="contentIMG"
        :alt="data.translation.slug"
        width="100%"
        :src="src"
    >
    <canvas id="screencast"></canvas>
</div>
</template>

<script>
export default {
    name: 'ContentImage',

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            screencastInfo: null,
            screencastConfig: null,
        };
    },

    computed: {
        src() {
            // Verificar se temos uma URL assinada para visualização no localStorage
            const signedApiUrls = localStorage.getItem(`lesson_${this.$route.params.lessonId}_api_urls`);

            if (signedApiUrls) {
                const apiUrls = JSON.parse(signedApiUrls);
                if (apiUrls && apiUrls.downloads && apiUrls.downloads[this.data.id]) {
                    return apiUrls.downloads[this.data.id].show;
                }
            }

            // Se não houver URL assinada, usar a URL normal
            return `/app/files/download/${this.data.id}/${this.data.secret}/show`;
        },
    },

    methods: {
        getScreencastInfo() {
            return window.axios
                .get('/api/app/lesson/content/screencast-info')
                .then(res => res.data)
                .catch(err => console.error(err));
        },

        getScreencastConfig() {
            return window.axios
                .get('/api/app/lesson/content/screencast-config')
                .then(res => res.data)
                .catch(err => console.error(err));
        },

        async screencastPost() {
            const screencastInfo = await this.getScreencastInfo();
            return screencastInfo;
        },

        async screencastConfigPost() {
            const screencastConfig = await this.getScreencastConfig();
            return screencastConfig;
        },

        async load() {
            this.screencastInfo = await this.screencastPost();
            this.screencastConfig = await this.screencastConfigPost();

            if (this.screencastConfig.status_lesson_content) {
                this.drawScreencast();
            }
        },

        drawScreencast() {
            const fontSize = parseInt(this.screencastConfig.fontSize.replace('px', ''));
            const screencastWidth = (this.screencastInfo.length * 5) * (fontSize / 10);
            const screencastHeight = fontSize;

            const canvas = document.getElementById('screencast');
            const content = document.getElementById('contentIMG');

            // A página atualiza caso o canvas seja removido dela
            if (canvas == undefined && content != undefined) {
                window.location.reload();
            } else if (canvas.classList.contains('__web-inspector-hide-shortcut__')) {
                window.location.reload();
            }

            const context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);

            // Redimensionando o canvas de acordo com o tamanho do conteúdo
            canvas.width = content.clientWidth;
            canvas.height = content.clientHeight;

            let positionX = Math.ceil(Math.random() * canvas.width);
            let positionY = Math.ceil(Math.random() * canvas.height);

            if (positionX + screencastWidth > canvas.width) {
                positionX -= ((positionX + screencastWidth) - canvas.width) + 10;
            }
            if (positionY + screencastHeight > canvas.height) {
                positionY -= screencastHeight;
            } else if (positionY - screencastHeight < 0) {
                positionY += screencastHeight;
            }

            context.fillStyle = this.screencastConfig.color;
            context.globalAlpha = this.screencastConfig.opacity / 100;
            context.font = `${this.screencastConfig.fontSize} Roboto`;
            context.fillText(this.screencastInfo, positionX, positionY);

            setTimeout(this.drawScreencast, this.screencastConfig.time);
        },
    },

};
</script>

<style scoped>
    canvas {
        position: absolute;
        top: 40px;
        left: 15px;
    }
    @media (max-width: 480px){
        canvas{
            top: 50px !important;
            width: 60vw !important;
            height: auto !important;
        }
    }
</style>
